import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ubs-ofbiz-summary-form',
  templateUrl: './ofbiz-summary-form.component.html',
  styleUrls: ['./ofbiz-summary-form.component.scss']
})
export class OfbizSummaryFormComponent implements OnInit {
  @Input() summaryView:any;
  @Input() existingValues:any;
  @Input() fieldList:any[];
  viewFields:any[] = [];
  
  constructor() { }

  ngOnInit(): void {
    console.log({summaryView:this.summaryView});
    console.log({existingValues:this.existingValues});
    console.log({fieldList:this.fieldList});
    this.fieldList.forEach(field => {
      if(field.title != "No Condition Find" && field.title != "Update" && field.title != "Submit" && field.title != "Find"){
        if(field.name in this.existingValues){
          field.value = this.existingValues[field.name];
        }
        this.viewFields.push(field); 
      }
    });
    let keys = Object.keys(this.existingValues);
    keys.forEach(key => {
      let checkField = this.fieldList.find(element => element.name === key);
      if(!checkField){
        let title = key.replace(/([a-z])([A-Z])/g, '$1 $2');
        this.viewFields.push({"title":title,value:this.existingValues[key]})
      }
    })
  }

}
